import React from 'react';

import toast from '../../components/toast';

const DEFAULT_MESSAGE = 'Algo salió mal. Inténtalo más tarde o contacta a un asesor';

const renderSomethingWentWrong = message => toast.danger(
  <p>{message ?? DEFAULT_MESSAGE}</p>,
  {
    time: 5000,
    iconName: 'icSadFaceWhite',
    iconAlt: 'Mensaje de error'
  }
);

export default renderSomethingWentWrong;
